<template>
  <div>
    <div class="dot">
      <div class="title">
        <h2>{{name}}部署情况</h2>
      </div>
      <div class="label">
        <div class="cn"></div>
        <span>中</span>
        <div class="us"></div>
        <span>美</span>
      </div>
      <div class="box1">
          <div v-for="(item, index) in origin" :key="index">
              <div style="display: flex;align-items: flex-end;">
                  <div class="box">
                      <div class="bottom-decorate"></div>
                      <div class="medium-part" :style="getMediumStyle(item.cn * 100)"></div>
                      <div class="top-part" :style="getTopStyle(item.cn * 100)"></div>
                      <div class="decorate-part" :style="getDecorateStyle(item.cn * 100)"></div>
                      <div class="score-part" :style="getScoreTextStyle(item.cn * 100)">{{item.cn * 1000 / 10}}</div>
                  </div>
                  <div class="box">
                      <div class="bottom-decorate green-bottom-decorate"></div>
                      <div class="medium-part green-medium-part" :style="getMediumStyle(item.us * 100)"></div>
                      <div class="top-part green-top-part" :style="getTopStyle(item.us * 100)"></div>
                      <div class="decorate-part green-decorate-part" :style="getDecorateStyle(item.us * 100)"></div>
                      <div class="score-part" :style="getScoreTextStyle(item.us * 100)">{{item.us * 1000 / 10}}</div>
                  </div>
              </div>
              <div class="time">{{item.date}}</div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getDoT} from "@/service/dashboard";
import {countryDict} from "@/theme/dict";

export default {
  data() {
    return {
      name: "",
      origin: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(dateString) {
      // 提取年月日部分
      const year = dateString.substring(0, 4);
      const month = dateString.substring(4, 6);
      const day = dateString.substring(6, 8);

      // 返回新的日期格式 MM-DD
      return `${month}-${day}`;
    },
    getData(){
      getDoT().then(res => {
        // 遍历原始数据数组
        this.name = res.name;
        let formattedData = res.data.map(item => {
          // 使用 formatDate 函数修改日期格式
          let formattedDate = this.formatDate(item.date);
          // 返回修改日期后的项

          return { ...item, date: formattedDate };
        });

        this.origin =formattedData;
      });
    },
    getMediumStyle(num) {
      return {
        "height": num / 90.8 * 115 / 192 + "rem",
        "backgroundSize": `0.10417rem ${num / 90.8 * 115 / 192}rem`
      };
    },
    getTopStyle(num) {
      return {
        "bottom": (num / 90.8 * 115 + 1) / 192 + "rem"
      };
    },
    getDecorateStyle(num) {
      return {
        "bottom": (num / 90.8 * 115 + 10) / 192 + "rem"
      };
    },
    getScoreTextStyle(num) {
      return {
        "bottom": (num / 90.8 * 115 + 21) / 192 + "rem"
      };
    }
  }
};


</script>
<style scoped lang="less">
.dot{
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  border-radius: 10px;
  padding-top: 10px;
  //padding-left: 35px;
  box-sizing: border-box;
  h2{
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    font-size: 24px;
    height: 31px;
    text-align: left;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
      padding-left: 35px;
  }
}
.label{
  //background-color: #5D96FF;
  position: absolute;
  right: 20px;
  top: 10px;
  width: 100px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  .cn{
    width: 15px;
    height: 15px;
    background-color: #3f93f3;
    margin: 0 6px;
  }
  .us{
    width: 15px;
    height: 15px;
    background-color: #00F6FF;
    margin: 0 6px;
  }
}
.box1 {
  width: 100%;
  height: 190px;
    //background-color: skyblue;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.box {
    width: 35px;
    height: 155px;
    /* background-color: skyblue; */
    position: relative;
    //margin-right: 9px;
}
.bottom-decorate {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 60px;
    background-image: url("../../assets/action/bottom-decorate.png");
    background-size: 100%;
}
.green-bottom-decorate {
    background-image: url("../../assets/action/green-bottom-decorate.png");
}
.medium-part {
    position: absolute;
    bottom: 9px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 115px;
    background-image: url("../../assets/action/medium-part.png");
    background-size: 100%;
    background-repeat: no-repeat;
}
.green-medium-part {
    background-image: url("../../assets/action/green-medium-part.png");
}
.top-part {
    position: absolute;
    bottom: 116px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 19px;
    background-image: url("../../assets/action/top-part.png");
    background-size: 100%;
}
.green-top-part {
    background-image: url("../../assets/action/green-top-part.png");
}
.decorate-part {
    position: absolute;
    bottom: 125px;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 31px;
    background-image: url("../../assets/action/decorate.png");
    background-size: 100%;
}
.green-decorate-part {
    background-image: url("../../assets/action/green-decorate.png");
}
.score-part {
    height: 18px;
    line-height: 18px;
    font-family: YouSheBiaoTiHei;
    font-size: 14px;
    position: absolute;
    bottom: 136px;
    left: 50%;
    transform: translateX(-50%);
    color: #FFF;
}
.time {
    color: #fff;
}
</style>